"use client";

import React from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const videos = [{
  title: "Watch us Start a Lavender Farm from Scratch",
  embedUrl: "https://www.youtube.com/embed/ScMzIvxBSi4?si=placeholder1"
}, {
  title: "How to Plant Lavender in Clay Soil",
  embedUrl: "https://www.youtube.com/embed/ScMzIvxBSi4?si=placeholder2"
}, {
  title: "Breaking Ground on the Lavender Field",
  embedUrl: "https://www.youtube.com/embed/ScMzIvxBSi4?si=placeholder3"
}];
export default function YouTubeGallery() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}